import axios from '../../utils/axios';

export default function updateLGCollection(adminId, billId, data) {
    return (
        axios.post(`/admin/${adminId}/lGCollection/${billId}/update`,  data )
    )
}
